import React, {useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import clsx from 'clsx'

let _unique = 0

export const ColorPickerContainer = ({
  classes = {root: ''},
  className,
  style = {},
  targetEl,
  show,
  children,
  onClose = () => {},
  offset = {x: 0, y: 0},
}) => {
  const [unique] = useState(`ds-menu-${_unique++}`)
  const refMenu = useRef()

  useEffect(() => {
    const el = targetEl?.current || targetEl
    if (!show || !el?.getBoundingClientRect) {
      refMenu.current.style.display = `none`
      return
    }

    const rect = el.getBoundingClientRect()

    refMenu.current.style.top = `${el.offsetTop + rect.height + offset?.y}px`
    refMenu.current.style.left = `${el.offsetLeft + offset?.x}px`
    refMenu.current.style.display = `flex`

    const fn = event => {
      if (!event.target.matches(`.${unique}.ds-menu--basic, .${unique}.ds-menu--basic *`)) {
        onClose(false)
      }
    }

    const d = document
    d.addEventListener('click', fn)

    return () => {
      d.removeEventListener('click', fn)
    }
  }, [show, unique, targetEl, onClose, offset])

  return (
    <div
      ref={refMenu}
      className={clsx('ds-menu--basic', classes?.root, className, unique)}
      style={{display: 'none', ...style}}
    >
      {children}
    </div>
  )
}
